<script>
    /* Imports */
    import FormularovePolicko from "./RezervacniFormular/FormularovePolicko.svelte";
    import TerminovyKalendar from "./RezervacniFormular/TerminovyKalendar.svelte";
    import { onMount } from 'svelte';
    import { APIrequestPOST } from "./js_libs/API_calls.js";
    import { shared_kontakty, shared_rezervacni_mista } from "./js_libs/SharedInformation.js";
    import BlokNacitani from "./BlokNacitani.svelte";
    import ShrnutiTerminu from "./RezervacniFormular/ShrnutiTerminu.svelte"
    import FormularovychViceMoznosti from "./RezervacniFormular/FormularovychViceMoznosti.svelte";
    import SluzbaVyber from "./RezervacniFormular/SluzbaVyber.svelte";

    /* Props */
    // Informace pro chybové hlášky rezervančního formuláře
    export const kontakty = {
        telefon : "+420 792 283 727",
        email: "studionatalis@seznam.cz"
    };

    // Rezervační místa, která lze kontaktovat s formulářem (API POINT - RES PLACE PARAMETER)
    export const rezervacni_mista = [
        {
            id: "natalia_skácelová",
            nazev: "Natalia Skácelová",
        },
        {
            id: "studio_natalis",
            nazev: "Studio Natalis",
        },
    ]

    let VybraneMisto = 1;

    /* Vlastnosti rezervačního formuláře */
    let JmenoZakaznika;
    let EmailZakaznika;
    let TelefonZakaznika;
    let PoznamkaZakaznika;
    let VybraneRezervaceZakaznika = [];
    // let SouhlasGDPR = false;
    let VybranaSluzba;
    let DelkaSluzby;



    let odpovedi = "";
    let problem = false;

    let ChybovyVyber;



    /* Funkce rezervačního formuláře */
    onMount(() => 
        {
            // $shared_kontakty = kontakty;
            // $shared_rezervacni_mista = w;
            
        }
    )

    const OsobyOptions = [
        {name: "Natalia Skácelová", value: 0},
        {name: "Studio Natalis", value: 1}
    ];

    /**
     * Validace formuláře
     * @returns {boolean} true, pokud je formulář validní, jinak false
     * @description Tato funkce provádí validaci formuláře a vrací true, pokud jsou všechna pole vyplněna správně.
     * Pokud některé pole není vyplněno, zobrazí se chybová hláška a vrátí false.
     */
    function ValidaceFormulare() 
    {
        // || !JmenoZakaznika.includes(" ")
        if(JmenoZakaznika?.length <= 0 || JmenoZakaznika === "")
        {
            console.error("Nevalidní formulář - Jméno zákazníka");
            return false;
        }
        else if(TelefonZakaznika?.replace(/\s+/g, '').length < 9 || TelefonZakaznika === "")
        {    
            console.error("Nevalidní formulář - Telefon");
            return false;
        }
        else if(EmailZakaznika?.length <= 0 || EmailZakaznika === "" || !(EmailZakaznika.includes("@") || EmailZakaznika.includes(".")))
        {
            console.error("Nevalidní formulář - Email");
            return false;
        }
        else if (VybraneRezervaceZakaznika?.length <= 0) 
        {
            console.error("Nevalidní formulář - Výběr rezervace");
            return false;
        }
        // else if (SouhlasGDPR == false) {
        //     console.error("Nevalidní formulář - Není souhlas s GDPR");
        //     return false;
        // }
        else if (ChybovyVyber) {
            console.error("Nevalidní formulář - Výběr obsahuje nemožné rezervace");
            return false;
        }
            
        

        return true;
    }

    /**
     * Odeslání formuláře
     * @returns {void}
     * @description Tato funkce odesílá formulář a provádí validaci. Pokud je formulář validní, odešle data na server.
     */
    async function OdeslatFormular()
    {
        const slotsCount = Math.ceil(Number(DelkaSluzby) / 30);


        if(ValidaceFormulare() === true) 
        {
            let data = [];

            const terminy = VybraneRezervaceZakaznika; 
            
            const slotsCount = Math.ceil(Number(DelkaSluzby) / 30);
            
            const addMinutes = (date, minutes) => new Date(date.getTime() + minutes * 60000);

            const pad2 = (n) => String(n).padStart(2, "0");

            const formatServerDate = (d) => {
                const yyyy = d.getFullYear();
                const mm = pad2(d.getMonth() + 1);
                const dd = pad2(d.getDate());
                const HH = pad2(d.getHours());
                const MM = pad2(d.getMinutes());
                const SS = pad2(d.getSeconds());
                return `${yyyy}-${mm}-${dd} ${HH}:${MM}:${SS}`;
            };

            const parseServerDate = (s) => new Date(s.replace(" ", "T"));

            let dataRequest = {
                "res_uuid": rezervacni_mista[VybraneMisto].id,
                "email": EmailZakaznika,
                "phone": TelefonZakaznika,
                "name" : JmenoZakaznika + " (" + VybranaSluzba + ")" 
                // "date" : terminy[0]?.start_time
            };

            // dataRequest['dates'] = terminy.map((termin) => {
            //     return termin.start_time;
            // });

            dataRequest.dates = terminy.flatMap((termin) => {
                const start = parseServerDate(termin.start_time);
                return Array.from({ length: slotsCount }, (_, i) =>
                    formatServerDate(addMinutes(start, i * 30))
                );
            });
            
            try {
                data = APIrequestPOST(
                    "reserveMultiple",
                    dataRequest
                );

                odpovedi = await data;
                console.log("Úspěšně zarezervováno!", dataRequest);
                console.log(await odpovedi);
            }
            catch(e) {
                problem = true;
                console.log("Pravděpodobně došlo ke kolizi rezervací.");
                setTimeout(() => {
                    problem = false;
                }, 15000);
            }           
        }
        else 
        {
            console.log("Nevalidní formulář.");
        }
    }
</script>

{#if odpovedi.length > 0}
<div style="min-height: 400px;">
     {#await odpovedi}
        <BlokNacitani height={"400px"} />
     {:then answer} 
        <div style="background-color: #C8E6C9; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #66BB6A;  margin: 20px 0 20px 0; display: flex; flex-direction: row; justify-content: center; align-items: center;">
            <p style="text-align: center">
                <strong style="color: #333">Vaše objednávka je potvrzena!</strong><br/> Na uvedený email bylo odesláno potvrzení termínu a času Vaši objednávky. <br/><br/>Děkujeme za Vaši objednávku a těším se na Vaši návštěvu.
            </p>
        </div>
    {:catch error}
        <div style="background-color: #FFCCCC; color: #333; padding: 20px; border-radius: 5px; border: 1px solid #FFA07A; margin: 20px 0 20px 0;">
            <strong style="color: #333">Chyba:</strong> Došlo k chybě při vytváření rezervace. Rezervace nebyla vytvořena. Pro rezervaci volejte na tel. číslo <strong style="color: #333">uvedené níže</strong> nebo to zkuste znovu.<br/>
            {error}
        </div>        
     {/await}
</div>
{:else}
<form 
    class="rezervacni-formular"
    style="display: flex; flex-direction: column; gap: 1.5rem; padding-bottom: 1.5rem;"
    on:submit|preventDefault={() => {OdeslatFormular()}}
    >

    <input 
        type="hidden"
        id="rezervacni-misto"
        name="rezervacni-misto"
        value={rezervacni_mista[VybraneMisto].id} 
        />

    
    <!-- <FormularovychViceMoznosti 
        labelTitle="Vyberte osobu: "
        placeholder=""
        id="osoba-zakaznika"
        required={true}
        options={OsobyOptions}
        bind:value={VybraneMisto} 
    /> -->

       
    {#key VybraneMisto}

    <!-- Výběr služby -->
    <SluzbaVyber 
        bind:place={VybraneMisto}
        bind:value={VybranaSluzba}
        bind:length={DelkaSluzby}
    />

    <!-- Výběr termínu -->
    <TerminovyKalendar 
        bind:VybraneRezervaceZakaznika
        bind:ChybovyVyber
        ResplaceUUID={rezervacni_mista[VybraneMisto].id}
    />
    {#if VybraneRezervaceZakaznika?.length <= 0}
        {#if ChybovyVyber}
            <p style="color:red;">Vybrané termíny nelze zarezervovat z důvodu plné kapacity nebo neplatného data.</p>
        {:else}
            <p style="color:red;">Vyberte prosím Váš termín rezervace.</p>
        {/if}
    {/if}

    <ShrnutiTerminu 
        bind:terminy={VybraneRezervaceZakaznika}
    />

    {/key}

    <FormularovePolicko 
        labelTitle="Vaše jméno*"
        placeholder="Zadejte jméno a příjmení"
        id="jmeno-zakaznika"
        required={true}
        bind:value={JmenoZakaznika} 
    />
    <!-- {#if JmenoZakaznika?.length > 0 && !(JmenoZakaznika.trim().includes(" ")) && !(JmenoZakaznika.trim().split(/\s+/).length >= 2)}
        <p style="color:red;">Zadejte prosím celé Vaše jméno a přijmení včetně mezery.</p>
    {/if} -->

    <FormularovePolicko 
        labelTitle="Váš telefon*"
        placeholder="Zadejte telefonní číslo"
        id="telefon-zakaznika"
        required={true}
        type="tel"
        bind:value={TelefonZakaznika} 
    />

    {#if TelefonZakaznika?.length > 0 && TelefonZakaznika?.replace(/\s+/g, '').length < 9 }
        <p style="color:red;">Telefonní číslo musí obsahovat alespoň 9 číslic.</p>
    {/if}

    <FormularovePolicko 
        labelTitle="Email pro potvrzení objednávky*"
        placeholder="Zadejte email"
        id="email-zakaznika"
        required={true}
        bind:value={EmailZakaznika} 
    />

    {#if EmailZakaznika?.length > 0 && !(EmailZakaznika.includes("@") || EmailZakaznika.includes(".")) }
        <p style="color:red;">Email musí být ve formátu email@domena.cz</p>
    {/if}

    

    <!-- <FormularovePolicko 
        labelTitle="Poznámka"
        placeholder="Zde můžete napsat poznámku k rezervaci"
        id="poznamka-zakaznika"
        type="textarea"
        bind:value={PoznamkaZakaznika} 
    /> -->

    <div 
        style="display: flex; justify-content: center; align-items: center; gap: 1rem;"
        >
        <button id="rezervovat" type="submit">Rezervovat</button>
    </div>
</form>
{/if}
{#if problem}
    <div id="problem">
        <p>Došlo k chybě při rezervaci. Váš vybraný termín pravděpodobně koliduje s jinou rezervací. Vyberte prosím jiný termín nebo to zkuste později.</p>
        <button on:click={() => {problem = false}}>Rozumím</button>
    </div>
{/if}

<style>
    #problem {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 9999;

        max-width: 600px;
        padding: 20px;
        border: 1px solid #f2b8b5;
        border-left: 5px solid #e57373;
        background-color: #fdecea;
        color: #5f2120;
        border-radius: 6px;
        font-family: system-ui, sans-serif;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        text-align: center;
    }

    #problem p {
        margin: 0 0 16px 0;
        line-height: 1.5;
    }

    #problem button {
        padding: 8px 18px;
        border: none;
        border-radius: 4px;
        background-color: #e57373;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        transition: background-color 0.2s ease, transform 0.1s ease;
    }

    #problem button:hover {
        background-color: #d32f2f;
    }

    #problem button:active {
        transform: scale(0.97);
    }



    button#rezervovat {
        /* -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        list-style-type: none!important;
        box-sizing: border-box;
        text-transform: uppercase;
        font-size: 16px;
        cursor: pointer;
        position: relative;
        line-height: 1 !important;
        font-style: normal !important;
        vertical-align: middle;
        transition: .3s;
        text-shadow: none!important;
        font-family: Lato,Helvetica,Arial,sans-serif;
        text-align: center;
        font-weight: 700;
        text-decoration: none!important;
        display: block;
        letter-spacing: 0;
        color: #fff !important;
        border: 1px solid #bc9321;
        outline: 0;
        padding: 1em 1.4em;
        margin: 30px 10px;
        box-shadow: none !important;
        border-color: #bc9321;
        background: #bc9321;
        border-radius: 99em; */
    }

    button#rezervovat:hover {
        /* color: rgb(188, 147, 33);
        background: none;
        border-color: rgb(188, 147, 33);         */
    }
</style>